import { Uppy } from '@uppy/core';
import { func, instanceOf } from 'prop-types';
import React from 'react';
import { ModalBody, ModalHeader } from 'reactstrap';

import createModalToggle from '../../generic/create-modal-toggle';
import DiscardableForm from '../../generic/DiscardableForm';
import FileUploader from '../../generic/FileUploader';
import CommentAttachmentsLabel from './CommentAttachmentsLabel';

const CommentsAttachmentForm = ({ toggle, onSuccess, uploader }) => {
  return (
    <>
      <ModalHeader toggle={toggle}>Attach files to comment</ModalHeader>
      <ModalBody>
        <DiscardableForm
          onSubmit={e => {
            e.preventDefault();
            e.stopPropagation();
            onSuccess();
          }}
          onDiscard={toggle}
        >
          <FileUploader
            hideUploadButton
            id="comment-attachments"
            manager={uploader}
            metaFields={[
              { id: 'name', name: 'Name', placeholder: 'File name' },
            ]}
            name="file"
            note="Select images, videos or documents..."
          />
          <div className="mb-3" />
        </DiscardableForm>
      </ModalBody>
    </>
  );
};

CommentsAttachmentForm.propTypes = {
  onSuccess: func.isRequired,
  toggle: func.isRequired,
  uploader: instanceOf(Uppy).isRequired,
};

export default createModalToggle(
  CommentAttachmentsLabel,
  CommentsAttachmentForm,
  {
    size: 'sm',
    className: 'position-relative px-1',
  },
);
